export let avatarOptions = {
	id: '',
	img: '',
	size: '',
	altText: '',
};

export const setter = (props) => {
	avatarOptions = {
		...avatarOptions,
		...props,
	};
};
